import { updates } from '@/mocks/homeData';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">实时追踪</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">影视快讯</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">每日追踪全球高清影视在线观看动态，第一时间掌握最新资讯</p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-8">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-14">
                <div className="absolute left-3.5 md:left-5.5 top-1.5 w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-accent-500 border-2 border-background-50 shadow-sm"></div>

                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-400 font-mono">{item.date}</span>
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">{item.tag}</span>
                </div>

                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.summary}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}